import React, { memo } from 'react';
import { Search } from 'lucide-react';

/**
 * Floating search button that toggles search panel visibility
 */
const SearchButton = memo(({ showSearch, setShowSearch }) => (
  <button 
    onClick={() => setShowSearch(!showSearch)}
    className={`bg-white dark:bg-neutral-900 text-neutral-600 dark:text-neutral-400 p-3 rounded-full shadow-lg backdrop-blur-sm transition-all duration-200 flex items-center justify-center pointer-events-auto hover:shadow-xl ${
      showSearch ? 'ring-2 ring-brand-primary' : ''
    }`}
    title="Search in chat"
    data-tour="search-button"
  >
    <Search size={18} />
  </button>
));

SearchButton.displayName = 'SearchButton';

export default SearchButton;